import { FixedType } from 'rc-table/lib/interface';
import * as React from 'react';
import { Cell, Column } from '../components/common';
import { useDataGridContext } from '../context';
import { filterColumnsForPosition, useFixedColumnStyles } from '../helpers';

interface FooterRowColumnsProps {
	position?: FixedType;
}

export const FooterRowColumn: React.FC<FooterRowColumnsProps> = ({ position }) => {
	const { columns } = useDataGridContext();
	const positionColumns = filterColumnsForPosition(columns, position);
	const columnStyles = useFixedColumnStyles(position);
	if (!positionColumns?.length) {
		return null;
	}
	let left = 0;
	return (
		<>
			{positionColumns?.map((c, columnIndex) => {
				const colStyle = position === 'left' ? { ...columnStyles, left } : columnStyles;
				left += Number(c.width);
				return (
					<Column key={`footerColumn: ${columnIndex}`} $width={c.width} style={colStyle}>
						{c.columnFooter ? <Cell>{c.columnFooter}</Cell> : null}
					</Column>
				);
			})}
			{position !== 'left' && position !== 'right' && (
				<div style={{ backgroundColor: 'red', width: '100%', height: '100%' }}>
					<Column $width="100%" style={{ width: '100%', flexGrow: 1, height: '100%' }}>
						<Cell style={{ width: '100%', height: 58, padding: 0 /* magic number */ }} />
					</Column>
				</div>
			)}
		</>
	);
};
